import { v4 } from 'uuid';
import { toastSlice, toastState } from '../context/ToastContext';
import { ToastInput } from '../ui/components/Toast';
import { useAppDispatch } from '../ui/pages/store';

export function useToast() {
  const dispatch = useAppDispatch();

  const closeToast = (id: string) => {
    toastState.items.delete(id);
    dispatch(toastSlice.actions.render());
  };

  return {
    generateId: () => v4(),
    toasts: toastState.items,
    closeToast,
    showToast: (props: ToastInput, timeout = props.type === 'error' ? 20 * 1000 : 5 * 1000) => {
      const id = props.id || v4();
      toastState.items.set(id, props);
      if (timeout > 0) setTimeout(() => closeToast(id), timeout);
      dispatch(toastSlice.actions.render());
      return id;
    },
  };
}
